import { InputAdornment } from '@material-ui/core';
import { Search, ExpandMore } from '@material-ui/icons';
import {
  FormikAutocompletePx,
  FormikTextFieldPx,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { CONTRACT_STATUS, OPCOS, OPCO_STATUS_FILTERS } from 'config/constants';

const FiltersRecords = ({ formik = {}, schools = {} }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <div className={classes.container}>
      <div className={global.filtersContainerHeader}>
        <div>
          <FormikAutocompletePx
            formik={formik}
            getOptionLabel={(option) => option.name || ''}
            label="Organisme de formation"
            name="school"
            options={schools}
            value={schools.find((school) => school?.id === formik?.values?.school?.id) || null}
            className={global.formikAutocomplete}
            endAdornment={(
              <ExpandMore style={{ color: '#5D75A8' }} />
            )}
          />
        </div>
        <div className={global.formikTextField}>
          <FormikTextFieldPx
            formik={formik}
            variant="outlined"
            name="trainingLabel"
            label="Intitulé de formation"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{ color: '#92ABD2' }} />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className={global.formikTextField}>
          <FormikTextFieldPx
            formik={formik}
            variant="outlined"
            name="studentName"
            label="Nom et prénom"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{ color: '#92ABD2' }} />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          <FormikAutocompletePx
            formik={formik}
            getOptionLabel={(option) => option.label || ''}
            label="Source OPCO"
            name="opcos"
            options={OPCOS}
            onChange={(e, value) => {
              formik.setFieldValue('opcos', value?.label || '');
            }}
            value={OPCOS.find((opco) => opco.label === formik.values.opcos) || ''}
            className={global.formikAutocomplete}
            endAdornment={(
              <ExpandMore style={{ color: '#5D75A8' }} />
            )}
          />
        </div>
        <div>
          <FormikAutocompletePx
            formik={formik}
            getOptionLabel={(option) => option.label || ''}
            label="Statut OPCO"
            name="opcoStatus"
            options={OPCO_STATUS_FILTERS}
            onChange={(e, value) => {
              formik.setFieldValue('opcoStatus', value?.value || '');
            }}
            value={OPCO_STATUS_FILTERS.find((opcoStatus) => opcoStatus.value === formik.values.opcoStatus) || ''}
            className={global.formikAutocomplete}
            endAdornment={(
              <ExpandMore style={{ color: '#5D75A8' }} />
            )}
          />
        </div>
        <div>
          <FormikAutocompletePx
            formik={formik}
            getOptionLabel={(option) => option.label || ''}
            label="Statut Contrat"
            name="contractStatus"
            options={CONTRACT_STATUS}
            onChange={(e, value) => {
              formik.setFieldValue('contractStatus', value?.value || '');
            }}
            value={CONTRACT_STATUS.find((contractStatus) => contractStatus.value === formik.values.contractStatus) || ''}
            className={global.formikAutocomplete}
            endAdornment={(
              <ExpandMore style={{ color: '#5D75A8' }} />
            )}
          />
        </div>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: spacing(2),
    '@media (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  disaggregatedButton: {
    display: 'flex',
    '@media (max-width: 1064px)': {
      display: 'none'
    },
  },
  aggregatedButton: {
    display: 'none',
    '@media (max-width: 1064px)': {
      display: 'flex'
    },
  }
});

export default FiltersRecords;
